/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Module } from '@msdyn365-commerce-modules/utilities';
import React from 'react';

import { IB2bRequestsStatusViewProps } from './b2b-requests-status';

const B2bRequestsStatusView: React.FC<IB2bRequestsStatusViewProps> = props => {
    const { b2bRequestsStatus, heading, table } = props;
    return (
        <Module {...b2bRequestsStatus}>
            {heading}
            {table}
        </Module>
    );
};

export default B2bRequestsStatusView;
